'use strict';

import jQuery from 'jquery';
import 'slick-carousel/slick/slick';

// Store local jQuery reference to avoid conflicts with other jQuery instances
const $ = jQuery;

$(function () {
    // Check if slick is available
    if (!$.fn.slick) {
        console.warn('Slick carousel not loaded yet');
        return;
    }
    /**
     * eg. references
     */
    $('[data-nezzo-contentslider]').slick({
        dots: true,
        infinite: true,
        speed: 600,
        slidesToShow: 1,
        autoplaySpeed: 5000,
        fade: true,

        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false
                }
            }
        ]
    });

    /**
     * Hero Slider
     */
    $('[data-nezzo-heroslider]').each(function () {
        const $this = $(this);
        const autoplay = $this.data('autoplay') !== false;
        let autoplaySpeed = parseInt($this.data('autoplay-speed')) || 5;
        if (autoplaySpeed < 100) { // If it's in seconds
            autoplaySpeed = autoplaySpeed * 1000;
        }

        $this.slick({
            dots: true,
            arrows: false,
            slidesToShow: 1,
            centerMode: true,
            centerPadding: '0',
            autoplay: autoplay,
            autoplaySpeed: autoplaySpeed,
            infinite: false,
        }).css('margin-bottom', 0);
    });

    /**
     * eg. news latest
     */
    const $slick_slider_xs = $('[data-nezzo-contentslider-xs]');
    const settings_slider_xs = {
        dots: true,
        slidesToShow: 1, // Shows the current slide and a bit of the next one
        centerMode: true,
        centerPadding: '16.5%',
        infinite: false,
        // fade: true,
        // slide: true,
        arrows: false
    }
    slick_on_mobile($slick_slider_xs, settings_slider_xs);

    // slick on mobile
    function slick_on_mobile(slider, settings) {
        $(window).on('load resize', function () {
            if ($(window).width() > 767) {
                if (slider.hasClass('slick-initialized')) {
                    slider.slick('unslick');
                }
                return
            }
            if (!slider.hasClass('slick-initialized')) {
                return slider.slick(settings);
            }
        });
    }

    function positionButtons() {
        const $container = $('.comparisonextended__table--row');
        const $prevButton = $container.find('.slick-prev.slick-arrow');
        const $nextButton = $container.find('.slick-next.slick-arrow');

        if ($container.length > 0) {
            const containerOffset = $container.offset();
            const containerWidth = $container.width(); // .width() returns the content width, excluding padding

            const paddingLeft = parseInt($container.css('padding-left'));
            const paddingRight = parseInt($container.css('padding-right'));

            const buttonHeight = $prevButton.outerHeight();  // Assuming both buttons have the same height

            const spacing = 90; // Spacing from the edge in pixels, adjust as needed

            $prevButton.css({
                'top': (containerOffset.top + ($container.outerHeight() / 2) - (buttonHeight / 2)) + 'px',
                'left': (containerOffset.left - spacing) + 'px', // Subtract spacing from left position
            });

            $nextButton.css({
                'top': (containerOffset.top + ($container.outerHeight() / 2) - (buttonHeight / 2)) + 'px',
                'left': (containerOffset.left + containerWidth + paddingLeft - $nextButton.outerWidth() + spacing) + 'px', // Add spacing after subtracting button width from left position
            });
        }
        let opacity = parseFloat($nextButton.css("opacity"));
        if (opacity == 0) {
            // console.log('left adjustment');
            $nextButton.css("left", "0px");
        }
    }

    /**
     * eg. comparison tiers on product pages
     */
    const $slideWideElements = $('[data-nezzo-slide-wide]');

    function setSlideNavVisibility($slideWideNav, slideBreakpoint, slideWideItemWidth, slideWideItem) {
        // console.log(slideBreakpoint, slideWideItemWidth, slideWideItem);

        if ((slideWideItemWidth || 0) < slideBreakpoint) {
            // $(slideWideItem).addClass('margin-right-10rem').removeClass('margin-right-5rem');

            $slideWideNav.show();

            var $slickList = $(slideWideItem).find('.slick-list');
            if ($slickList.length > 0) {
                // console.log($slickList);
                // $slickList.removeClass('hidden');
            }
        } else {
            // $(slideWideItem).addClass('margin-right-5rem').removeClass('margin-right-10rem');

            $slideWideNav.hide();

            var $slickList = $(slideWideItem).find('.slick-list');
            if ($slickList.length > 0) {
                // console.log($slickList);
                // $slickList.addClass('hidden');
            }
        }

        setTimeout(() => {
            $slideWideElements.filter('.comparisonextended__table--row').each((index, itemSlider) => {
                setActiveSliderArrowsVisibility($(itemSlider));
            });
            slideWideItem.find('.slick-slide').each((i, itemSliderWide) => {
                // console.log(itemSliderWide, itemSliderWide.clientWidth);
                if (itemSliderWide.clientWidth > 384) {
                    $(itemSliderWide).find('.comparisonextended--disruptor').addClass('wide');
                } else {
                    $(itemSliderWide).find('.comparisonextended--disruptor').removeClass('wide');
                }
            });
        }, 100);

    }

    function setActiveSlide($slideWideItem, slideBreakpoint, slideToItem) {
        if ((document.documentElement.clientWidth || 0, window.innerWidth || 0) < slideBreakpoint) {
            $($slideWideItem).slick('slickGoTo', slideToItem);
        }
    }

    function updateArrowVisibility(slider, currentSlide, slideCount) {
        $(slider).prev().children().children().find('.slick-slide.slick-active').each((index, slickSlidePrev) => {
            const currentSlideIndexPrev = parseInt($(slickSlidePrev).attr('data-slick-index'));
            if (currentSlideIndexPrev === currentSlide) {
                $(slickSlidePrev).addClass('slick-current');
            } else {
                $(slickSlidePrev).removeClass('slick-current');
            }
        });
        $(slider).next().children().children().find('.slick-slide.slick-active').each((index, slickSlide) => {
            const currentSlideIndex = parseInt($(slickSlide).attr('data-slick-index'));
            if (currentSlideIndex === currentSlide) {
                $(slickSlide).addClass('slick-current');
            } else {
                $(slickSlide).removeClass('slick-current');
            }
        });
        if (currentSlide === 0) {
            slider.find('.slick-prev').hide();
        } else {
            slider.find('.slick-prev').show();
        }

        if (currentSlide === slideCount - 1) {
            slider.find('.slick-next').hide();
        } else {
            slider.find('.slick-next').show();
        }
    }

    function isElementInViewport($el) {
        const rect = $el.get(0).getBoundingClientRect();
        const windowHeight = $(window).height();
        const windowWidth = $(window).width();

        return (
            rect.top <= windowHeight &&
            rect.left <= windowWidth &&
            rect.bottom >= 0 &&
            rect.right >= 0
        );
    }

    function setActiveSliderArrowsVisibility($itemSlider) {
        if (isElementInViewport($itemSlider)) {
            const sliderOffset = $itemSlider.offset().top;
            const windowHeight = $(window).height();
            const scrollPosition = $(window).scrollTop();
            const sliderHeight = $itemSlider.outerHeight();
            const sliderBottom = sliderOffset + sliderHeight;
            const $arrows = $($itemSlider).find('.slick-arrow');

            if ((scrollPosition) > (sliderOffset - windowHeight / 2) && (scrollPosition + windowHeight / 2) < sliderBottom) {
                $arrows.css({
                    'position': 'fixed',
                    'top': '50%',
                    'transform': 'translateY(-50%)',
                    'opacity': '1' // Set opacity to 1
                });
            } else {
                $arrows.css({
                    'position': 'absolute',
                    'top': 'auto',
                    'transform': 'none',
                    'opacity': '0' // Set opacity to 0
                });
            }

            // let opacity = parseFloat($($itemSlider).find('.slick-next').css("opacity"));
            // if(opacity == 0) {
            //     $($itemSlider).find('.slick-next').css({'left': '0px'});
            // } else {
            //     $($itemSlider).find('.slick-next').css({'left': 'auto'});
            // }
        // } else {
            // $($itemSlider).find('.slick-next').css({'left': '0px'});
        // }
        }
    }

    window.onscroll = function () {
        $slideWideElements.filter('.comparisonextended__table--row').each((index, itemSlider) => {
            setActiveSliderArrowsVisibility($(itemSlider));
        });
    };

    let slideWideDataArray = [];

    $slideWideElements.each((index, slideWideItem) => {
        const $slideWideItem = $(slideWideItem);
        const $slideWideNav = $($slideWideItem).prev('[data-nezzo-slide-wide-nav]').add($($slideWideItem).next('[data-nezzo-slide-wide-nav]').length > 0 ? $($slideWideItem).next('[data-nezzo-slide-wide-nav]') : []);
        // const $slideNavItems = $($slideWideItem).find('[data-nezzo-slide-nav-item]').clone();
        const $slideDotNavItems = $($slideWideNav).find('[data-nezzo-slide-wide-nav-dot]').clone();
        const $slideItems = $($slideWideItem).find('[data-nezzo-slide-item]');
        const slideCount = $slideItems.length;
        const slideBreakpoint = slideCount * 320;
        const slideWideItemWidth = $($slideWideItem).innerWidth();
        let topSellerIndex = 0;

        $slideItems.each((itemIndex, $item) => {
            if ($($item).data('nezzoSlideItem') === 'center') {
                topSellerIndex = itemIndex;
            }
        });

        if ($slideDotNavItems.length > slideCount) {
            $slideDotNavItems.splice(slideCount, $slideDotNavItems.length - slideCount);
        }
        $slideWideNav.html($slideDotNavItems);

        // if ($slideNavItems.length > 0 && $slideNavItems.length === $slideItems.length) {
        //     $slideWideNav.html($slideNavItems);
        // }

        slideWideDataArray.push({
            $slideWideNav,
            slideBreakpoint,
            slideWideItemWidth,
            $slideWideItem,
            topSellerIndex
        });

        // Initialize the main slider first to avoid double-init via asNavFor
        $($slideWideItem).on('afterChange', function (event, slick, currentSlide) {
            currentSlide = currentSlide || 0; // In case currentSlide is undefined
            if ($(slick.$slider).hasClass('comparisonextended__table--row')) {
                updateArrowVisibility($(slick.$slider), currentSlide, slick.slideCount);
            }
        }).slick({
            // arrows: false,
            draggable: false,
            centerMode: false,
            slidesToShow: slideCount,
            infinite: false,
            respondTo: 'slider',
            asNavFor: $slideWideNav,
            responsive: [
                // {
                //     breakpoint: slideBreakpoint + 1,
                //     settings: 'unslick'
                // },
                {
                    breakpoint: slideBreakpoint,
                    settings: {
                        centerMode: true,
                        centerPadding: 'calc((100% - 320px) / 2)',
                        draggable: true,
                        slidesToShow: 1,
                        initialSlide: slideWideDataArray[index].topSellerIndex
                    }
                }
            ]
        });

        // Initialize the nav slider only if not already initialized by asNavFor above
        if (!$slideWideNav.hasClass('slick-initialized')) {
            $slideWideNav.slick({
                slidesToShow: 6,
                slidesToScroll: 1,
                initialSlide: slideWideDataArray[index].topSellerIndex,
                arrows: true,
                infinite: true,
                focusOnSelect: true,
                asNavFor: $($slideWideItem)
            });
        }
    
        setActiveSlide($slideWideItem, slideBreakpoint, topSellerIndex);


        window.onresize = function () {
            positionButtons();
            slideWideDataArray.forEach((slideWideData) => {
                setSlideNavVisibility(slideWideData.$slideWideNav, slideWideData.slideBreakpoint, slideWideData.slideWideItemWidth, slideWideData.$slideWideItem);
                // setActiveSlide(slideWideData.$slideWideItem, slideWideData.slideBreakpoint, slideWideData.topSellerIndex);
            });
        };
        positionButtons();
        setSlideNavVisibility($slideWideNav, slideBreakpoint, slideWideItemWidth, $slideWideItem);

    });
});
